// extracted by mini-css-extract-plugin
export default {"container":"TabPanel_container__MO-Gj","content":"TabPanel_content__DoxSC"};